var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12.1191,
    width: 22,
    height: 13,
    rx: 6.5,
    fill: "#C4CBDC",
    stroke: "#DFE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9322 18.4291L9.49023 17.5891L9.95223 16.8051L11.3942 17.6451V15.9791H12.3042V17.6451L13.7462 16.8051L14.2082 17.5891L12.7522 18.4291L14.2082 19.2691L13.7462 20.0531L12.3042 19.2131V20.8931H11.3942V19.2131L9.95223 20.0531L9.49023 19.2691L10.9322 18.4291Z",
    fill: "#F6F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6334 18.4291L15.1914 17.5891L15.6534 16.8051L17.0954 17.6451V15.9791H18.0054V17.6451L19.4474 16.8051L19.9094 17.5891L18.4534 18.4291L19.9094 19.2691L19.4474 20.0531L18.0054 19.2131V20.8931H17.0954V19.2131L15.6534 20.0531L15.1914 19.2691L16.6334 18.4291Z",
    fill: "#F6F7FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3346 18.4291L20.8926 17.5891L21.3546 16.8051L22.7966 17.6451V15.9791H23.7066V17.6451L25.1486 16.8051L25.6106 17.5891L24.1546 18.4291L25.6106 19.2691L25.1486 20.0531L23.7066 19.2131V20.8931H22.7966V19.2131L21.3546 20.0531L20.8926 19.2691L22.3346 18.4291Z",
    fill: "#F6F7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePinIcon);
export default __webpack_public_path__ + "static/media/changePinIcon.ca4d91c28ad562c82fd31c31bdfa0e70.svg";
export { ForwardRef as ReactComponent };